import { truncateWithEllipsis } from '@kaiizen/kai-presenters';
import { Fragment, type ReactNode } from 'react';

import { DEFAULT_MAIN_NAVIGATION_CONFIG, type MainNavigationActionArgs, type MainNavigationConfig } from './mainNavigationConfig';
import { MAIN_NAVIGATION_STYLES } from './mainNavigationStyles';

export const TITLE_MAX_LENGTH = 50;

export const MainNavigation = ({
  args,
  config = DEFAULT_MAIN_NAVIGATION_CONFIG,
  header,
  title,
}: {
  args?: MainNavigationActionArgs;
  config?: MainNavigationConfig;
  /** Slot between the main navigation and scrollable content (project lifecycle routes only) */
  header?: ReactNode;
  title: string;
}) => {
  const { actions, onAddressClick } = config;
  const dynamicActions = args
    ? actions
      .map(({ id, buttonAction }) => ({ id, node: buttonAction(args) }))
      .filter((entry): entry is { id: string; node: ReactNode } => Boolean(entry.node))
      .map(({ id, node }) => <Fragment key={id}>{node}</Fragment>)
    : [];

  return (
    <header data-main-navigation='true' css={MAIN_NAVIGATION_STYLES.root}>
      <span onClick={() => onAddressClick(args)} css={MAIN_NAVIGATION_STYLES.address}>
        {truncateWithEllipsis(title, TITLE_MAX_LENGTH)}
      </span>
      {header}
      {/* The header slot grows to fill this space itself (its own flex: 1) — the filler span would otherwise split the remaining width with it and leave a gap before actions. */}
      {header ? null : <span css={MAIN_NAVIGATION_STYLES.filler} />}
      <div css={MAIN_NAVIGATION_STYLES.actionsContainer}>{dynamicActions}</div>
    </header>
  );
};
